
let ws = null;
let currentKey = '';
let reconnectTimer = null;
let reconnectAttempts = 0;
let manualClose = false;

const WS_URL = buildDefaultWSURL();
const WS_SITENAME = 'esamprod';
const MAX_RECONNECT_DELAY = 30000;

export function conectarws(datauser,store) {
  const apidev = process.env.VUE_APP_GRAPHQL;
  const username = getUsername(datauser);
  let sitename = WS_SITENAME;
  if (apidev.includes('apidev')) sitename = 'esamtest'

  if (!username) {
    cerrarws(); 
    return null;
  }

  const connectionKey = `${sitename}:${username}`;
  if (ws && currentKey === connectionKey && ws.readyState !== WebSocket.CLOSED) {
    return ws;
  }

  cerrarws();
  manualClose = false;
  currentKey = connectionKey;

  const url = buildURL(username, sitename);
  window.console.log('ws conectando', { url, username, sitename });

  ws = new WebSocket(url);

  ws.onopen = function() {
    reconnectAttempts = 0;
    window.console.log('ws conectado', { username, sitename });
  };

  ws.onclose = function(event) {
    window.console.log('ws desconectado', {
      username,
      sitename,
      code: event.code,
      reason: event.reason,
      wasClean: event.wasClean,
    });
    if (!manualClose && currentKey === connectionKey) {
      scheduleReconnect(datauser);
    }
  };

  ws.onerror = function(error) {
    window.console.error('ws error', {
      url: ws ? ws.url : '',
      readyState: ws ? ws.readyState : null,
      error,
    });
  };

  ws.onmessage = function(event) {
    try {
      const message = JSON.parse(event.data);

      if (!message.sitename || message.sitename !== sitename) {
        return;
      }

      if (store) {
        store.commit('setConsWs', message);
      }

      window.console.log('ws mensaje', message);
    } catch (error) {
      window.console.error('ws mensaje invalido', event.data, error);
    }
  };

  return ws;
}

export function cerrarws() {
  manualClose = true;
  clearReconnect();

  if (ws) {
    ws.close();
  }

  ws = null;
  currentKey = '';
}

function scheduleReconnect(datauser) {
  clearReconnect();
  reconnectAttempts += 1;
  const delay = Math.min(1000 * Math.pow(2, reconnectAttempts - 1), MAX_RECONNECT_DELAY);
  reconnectTimer = window.setTimeout(function() {
    reconnectTimer = null;
    conectarws(datauser);
  }, delay);
}

function clearReconnect() {
  if (reconnectTimer) {
    window.clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
}

function buildURL(username, sitename) {
  const url = new URL(WS_URL);
  url.searchParams.set('username', username);
  url.searchParams.set('sitename', sitename);
  return url.toString();
}

function buildDefaultWSURL() {
  /* const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const hostname = window.location.hostname || '127.0.0.1';
  return `${protocol}//${hostname}:4045/ws`; */
  return `wss://wsx.sladia.site/ws`; 
}

function getUsername(datauser) {
  if (!datauser) {
    return '';
  }

  return String(datauser.username || datauser.num_doc || datauser.id || '').trim();
}
